document.addEventListener('DOMContentLoaded', () => {
  let burgerMenu = document.querySelector(".burger-menu")
  if(burgerMenu) {
    let icon = burgerMenu.querySelector(".burger")
    let sidebar = document.querySelector(".sidebar")
    icon.addEventListener("click", (e) => toggleBurgerMenu(e))

    const toggleBurgerMenu = (e) => {
      e.preventDefault();
      toggleClass(burgerMenu, "open")
      toggleClass(icon, "open")
      toggleClass(sidebar, "open")
    }
  }

  if(document.getElementById("toggle-sidebar")) {
    let toggleSidebarEl = document.getElementById("toggle-sidebar")
    let sidebarEl = document.querySelector(".sidebar")
    let dashboardEl = document.querySelector("main.dashboard")
    toggleSidebarEl.addEventListener("click", (e) => {
      e.preventDefault()
      toggleClass(sidebarEl, "closed")
      toggleClass(dashboardEl, "sidebar-closed")
    })
  }

  setSidebarHeight()
  window.addEventListener("resize", setSidebarHeight)
})

// Dynamically set sidebar height
function setSidebarHeight() {
  let sidebar = document.querySelector(".sidebar")
  if(sidebar) {
    let winHeight = window.innerHeight
    if(winHeight > 450) {
      sidebar.style.height = winHeight + "px"
      sidebar.style.minHeight = winHeight + "px"
      sidebar.classList.remove("overflow-y")
    } else {
      sidebar.classList.add("overflow-y")
      sidebar.style.height = "100vh"
      sidebar.style.minHeight = "100vh"
    }
  }
}

const toggleClass = (el, className) => {

  if (el.classList) {
    el.classList.toggle(className);
  } else {
    var classes = el.className.split(' ');
    var existingIndex = classes.indexOf(className);

    if (existingIndex >= 0)
      classes.splice(existingIndex, 1);
    else
      classes.push(className);

    el.className = classes.join(' ');
  }
}


// missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}
